import { Redirect } from "wouter";
import { useStore } from "../store";

export function Home() {
  const authToken = useStore((state) => state.authToken);
  const profile = useStore((state) => state.profile);
  if (profile && profile.plan !== "Free") 
    return <Redirect to="/generate" />;
  if (authToken)
    return <Redirect to="/gallery" />;
  return <Redirect to="/auth" />;
}

export default Home;
